import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Upcoming from "@/pages/Upcoming";
import Recurring from "@/pages/Recurring";
import Reports from "@/pages/Reports";
import Categories from "@/pages/Categories";
import Layout from "@/components/Layout";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const Public = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors theme="dark" />
          <Routes>
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/register" element={<Public><Register /></Public>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/islemler" element={<Protected><Transactions /></Protected>} />
            <Route path="/yaklasan" element={<Protected><Upcoming /></Protected>} />
            <Route path="/abonelikler" element={<Protected><Recurring /></Protected>} />
            <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
            <Route path="/kategoriler" element={<Protected><Categories /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
